import React, { useEffect } from 'react';
import { TmntText, TmntHtml } from '../../Common';
import QRCodeReturn from './QRCodeReturn';
import { stepTwoProps } from './props';

const shippingConfig = [
  {
    key: 'returnByDate',
    check: (props) => props.returnByDate && props.title?.value !== 'returninstore',
    render: (props) => <p><TmntText tmnt={props.returnByDate} /></p>,
  },
  {
    key: 'qrCode',
    check: (props) => props.rmaNumber && props.title?.value !== 'returninstore',
    render: (props) => <QRCodeReturn rmaNumber={props.rmaNumber} />,
  },
  {
    key: 'searchQRCodeLocations',
    check: (props) => props.searchQRCodeLocations && props.title?.value !== 'returninstore',
    render: (props) => (
      <p>
        <TmntHtml tmnt={props.searchQRCodeLocations} />
      </p>
    ),
  },
  {
    key: 'returnAvoidCancellation',
    check: (props) => props.returnAvoidCancellation && props.title?.value !== 'returninstore',
    render: (props) => (
      <p>
        <TmntText tmnt={props.returnAvoidCancellation} />
      </p>
    ),
  },
  {
    key: 'carrierLocator',
    check: (props) => props.carrierLocator && props.title?.value !== 'returninstore',
    render: (props) => (
      <p>
        <TmntHtml tmnt={props.carrierLocator} />
      </p>
    ),
  },
  {
    key: 'returnLabelGenerated',
    check: (props) => props.returnLabelGenerated && props.title?.value !== 'returninstore',
    render: (props) => (
      <p>
        <TmntText tmnt={props.returnLabelGenerated} />
      </p>
    ),
  },
  {
    key: 'returnLabelWaiting',
    check: (props) => props.returnLabelWaiting && props.title?.value !== 'returninstore',
    render: (props) => (
      <p>
        <TmntText tmnt={props.returnLabelWaiting} />
      </p>
    ),
  },
  {
    key: 'nextStepsQRCodeProvided',
    check: (props) => props.nextStepsQRCodeProvided && props.title?.value !== 'returninstore',
    render: (props) => <p><TmntHtml tmnt={props.nextStepsQRCodeProvided} /></p>,
  },
  {
    key: 'dhlReturnNote',
    check: (props) => props.dhlReturnNote && props.title?.value !== 'returninstore',
    render: (props) => (
      <p>
        <TmntText tmnt={props.dhlReturnNote} />
      </p>
    ),
  },
  {
    key: 'dhlReturnNumber',
    check: (props) => props.dhlReturnNumber && props.title?.value !== 'returninstore',
    render: (props) => (
      <p>
        <TmntText tmnt={props.dhlReturnNumber} />
      </p>
    ),
  },
  {
    key: 'qrCodePurolatorServiceDetails',
    check: (props) => props.qrCodePurolatorServiceDetails && props.title?.value !== 'returninstore',
    render: (props) => (
      <p>
        <TmntText tmnt={props.qrCodePurolatorServiceDetails} />
      </p>
    ),
  },
  {
    key: 'eligibleDropOffLocations',
    check: (props) => props.eligibleDropOffLocations && props.title?.value !== 'returninstore',
    render: (props) => (
      <p>
        <TmntHtml tmnt={props.eligibleDropOffLocations} />
      </p>
    ),
  },
  {
    key: 'returnLabelProvided',
    check: (props) => props.returnLabelProvided && props.title?.value !== 'returninstore',
    render: (props) => (
      <p>
        <TmntHtml tmnt={props.returnLabelProvided} />
      </p>
    ),
  },
  {
    key: 'returnMethodCustomerShippingShipTo',
    check: (props) => props.returnMethodCustomerShippingShipTo && props.title?.value !== 'returninstore',
    render: (props) => (
      <p>
        <TmntHtml tmnt={props.returnMethodCustomerShippingShipTo} />
      </p>
    ),
  },
  {
    key: 'returnAddress',
    check: (props) => props.returnAddress && props.title?.value !== 'returninstore',
    render: (props) => (
      <div>
        <TmntHtml tmnt={props.returnAddress} />
      </div>
    ),
  },
];

export default function StepTwoContent({ stepTwo }) {
  const isReturnInStore = stepTwo.title?.value === 'returninstore';

  useEffect(() => {
    // Only trigger DRE 2.0 start event for return in store
    if (isReturnInStore && typeof window !== 'undefined' && window.hasDRE20) {
      // Trigger the DRE 2.0 start event
      window.dispatchEvent(new CustomEvent('dre20:start', { detail: { target: 'rne-dre' } }));
    }
  }, [isReturnInStore]);

  return (
    <div className="step2-shipping-method-content" data-testid="shipping-method-content">
      {shippingConfig.map(({ key, check, render }) => {
        if (!check(stepTwo)) return null;
        return <React.Fragment key={key}>{render(stepTwo)}</React.Fragment>;
      })}
      {isReturnInStore && (
        <div id="rne-dre" className="dre-mfe-parent-wrapper" data-testid="rne-dre-container" />
      )}
    </div>
  );
}

StepTwoContent.propTypes = {
  stepTwo: stepTwoProps.isRequired,
};
